<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Évolution de la taxe foncière</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/ss_taxe_fonciere.png" class="img-fluid"/>
        <div class="card-text row" *ngIf="!preview && hasData()">
            <div echarts [options]="options" [merge]="data" class="chart" (chartInit)="onChartInit($event)"></div>
        </div>
        <p class="text-center no-data" *ngIf="!preview && !hasData()">
            Pas de données
        </p>
        <p style="font-size: 10px;margin-top:0px; margin-bottom: 0px; text-align: right;">
            Source : DGFiP
        </p>
    </div>
</div>
